import React, { useState } from 'react';
import { Tabs } from 'antd';
import { UserOutlined, LockOutlined, LinkOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useSearchParams, useNavigate } from 'react-router';
import { useCommonStore } from "../../store/useCommonStore";
import useRequest from "@/utils/useRequest";

// 导入拆分的组件
import BasicInfoTab from './BasicInfoTab';
import SecurityTab from './SecurityTab';
// import ExtendedInfoTab from './ExtendedInfoTab';
import AccountBindingTab from './AccountBindingTab';

const ProfileSettings = () => {
    const { request } = useRequest();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    
    const user = useCommonStore.use.user();
    const areatree = useCommonStore.use.areatree();
    const [loading, setLoading] = useState(false);
    
    // 从URL参数获取当前tab，默认为'profile'
    const currentTab = searchParams.get('tab') || 'profile';
    
    // 处理tab切换
    const handleTabChange = (activeKey) => {
        setSearchParams({ tab: activeKey });
    };
    

    
    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div>加载中...</div>
            </div>
        );
    }
    
    if (!user) {
        return (
            <div className="flex justify-center items-center h-64">
                <div>用户信息加载失败</div>
            </div>
        );
    }
    
    return (
        <div className="h-full flex flex-col bg-gray-50">
            <div className="flex-shrink-0 bg-white border-b border-gray-200 px-6 py-4">
                <h1 className="text-2xl font-bold text-gray-900">个人设置</h1>
                <p className="text-gray-600 mt-1">管理您的个人信息和账户设置</p>
            </div>
            
            <div className="flex-1 overflow-hidden">
                <Tabs 
                    activeKey={currentTab}
                    onChange={handleTabChange}
                    tabPosition="left"
                    className="h-full profile-settings-tabs"
                    tabBarStyle={{ paddingTop: '24px', paddingBottom: '24px', marginRight: 0, backgroundColor: '#fff', flexShrink: 0 }}
                    style={{
                        height: '100%',
                        display: 'flex'
                    }}
                    items={[
                            {
                                key: 'profile',
                                label: (
                                    <span className="flex items-center">
                                        <UserOutlined className="mr-2" />
                                        基本信息
                                    </span>
                                ),
                                children: <BasicInfoTab user={user} areatree={areatree} />
                            },
                            {
                                key: 'security',
                                label: (
                                    <span className="flex items-center">
                                        <LockOutlined className="mr-2" />
                                        安全设置
                                    </span>
                                ),
                                children: <SecurityTab />
                            },
                            // {
                            //     key: 'extended',
                            //     label: (
                            //         <span className="flex items-center">
                            //             <InfoCircleOutlined className="mr-2" />
                            //             扩展信息
                            //         </span>
                            //     ),
                            //     children: <ExtendedInfoTab user={user} />
                            // },
                            {
                                key: 'binding',
                                label: (
                                    <span className="flex items-center">
                                        <LinkOutlined className="mr-2" />
                                        账户绑定
                                    </span>
                                ),
                                children: <AccountBindingTab user={user} />
                            }
                        ]}
                />
            </div>
        </div>
    );
};

export default ProfileSettings;